<template>
  <div class="main-color">
    <div class="container">
      <div class="row justify-content-center align-items-center mh-100vh text-center">
        <div class="col-lg-6 row">
          <b-overlay :show="overlayShow" rounded="sm" class="col-lg-12 row justify-content-center p-0">
            <form method="post" class="base-color col-lg-12 p-5">
              <h2>アカウント作成</h2>
              <hr>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="bag"></b-icon>
                    </span>
                  </div>
                  <input type="text" class="form-control" name="traderCd" placeholder="業者コード" required="required">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="envelope"></b-icon>
                    </span>
                  </div>
                  <input type="email" class="form-control" name="email" placeholder="メールアドレス" required="required">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="lock"></b-icon>
                    </span>
                  </div>
                  <input type="text" class="form-control" name="password" placeholder="パスワード" required="required">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 45px">
                      <b-icon icon="lock"></b-icon>
                      <b-icon icon="check" shift-h="-15" shift-v="-2"></b-icon>
                    </span>
                  </div>
                  <input type="text" class="form-control" name="confirm_password" placeholder="パスワード確認用" required="required">
                </div>
              </div>
              <div class="form-group">
                <label class="form-check-label">
                  <input type="checkbox" required="required"> <a href="#">利用規約</a> と<a href="#">プライバシーポリシー</a> に同意します
                </label>
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-primary btn-lg" @click.stop.prevent="sendMail()">確認メール送信</button>
              </div>
            </form>
            <div class="col-lg-12 row justify-content-center base-color">
              <div class="text-center">
                すでにアカウントをお持ちのかたは
                  <b-link href="/trader/login">こちら</b-link>
                でログインしてください
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
    <commonModal title="" body="送信されたメール内のURLにアクセスしてください"/>
  </div>
</template>
<script>
import CommonModal from '@/components/CommonModal'
export default {
  name: 'TraderSignup',
  components: { CommonModal },
  data () {
    return {
      overlayShow: false
    }
  },
  methods: {
    sendMail () {
      this.overlayShow = true
      setTimeout(() => {
        this.isSelectComplete = true
        this.overlayShow = false
        this.$bvModal.show('common-modal')
      }, 4000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TraderSignup.vue